import {
  GroupDTO,
  ModelDTO,
  ModificationsResponseDTO,
  PartsModelDTO,
  SearchByVinDTO,
  TypeDTO,
} from '../../types';

// Action type constants
export const CATALOG_RESET = 'CATALOG_RESET';
export const CATALOG_SET_CAR_TYPE = 'CATALOG_SET_CAR_TYPE';
export const CATALOG_SET_MARK = 'CATALOG_SET_MARK';
export const CATALOG_SET_ALL_MARKS = 'CATALOG_SET_ALL_MARKS';
export const CATALOG_SET_MODEL = 'CATALOG_SET_MODEL';
export const CATALOG_SET_MODIFICATION = 'CATALOG_SET_MODIFICATION';
export const CATALOG_SET_GROUPS = 'CATALOG_SET_GROUPS';
export const CATALOG_SET_PARENT_GROUPS = 'CATALOG_SET_PARENT_GROUPS';
export const CATALOG_CURRENT_STEP = 'CATALOG_CURRENT_STEP';

export const CATALOG_SELECT_CAR_TYPE = 'CATALOG_SELECT_CAR_TYPE';
export const CATALOG_SELECT_MARK = 'CATALOG_SELECT_MARK';

export const GET_MODEL_BY_BRAND_REQUEST = 'GET_MODEL_BY_BRAND_REQUEST';
export const GET_MODEL_BY_BRAND_SUCCESS = 'GET_MODEL_BY_BRAND_SUCCESS';
export const GET_MODEL_BY_BRAND_FAILURE = 'GET_MODEL_BY_BRAND_FAILURE';

export const GET_MODIFICATION_BY_MODEL_REQUEST = 'GET_MODIFICATION_BY_MODEL_REQUEST';
export const GET_MODIFICATION_BY_MODEL_SUCCESS = 'GET_MODIFICATION_BY_MODEL_SUCCESS';
export const GET_MODIFICATION_BY_MODEL_FAILURE = 'GET_MODIFICATION_BY_MODEL_FAILURE';

// State interface
export interface CatalogState {
  isLoading: {
    searchByVIN?: boolean;
    catalog?: boolean;
    model?: boolean;
    modification?: boolean;
    groups?: boolean;
    subGroups?: boolean;
    parts?: boolean;
    scheme?: boolean;
  };
  errors: {
    searchByVIN?: string | null;
    catalog?: string | null;
    model?: string | null;
    modification?: string | null;
    groups?: string | null;
    subGroups?: string | null;
    parts?: string | null;
    scheme?: string | null;
  };
  searchByVIN: SearchByVinDTO | null;
  typesList: TypeDTO[] | null;
  marksList: TypeDTO['marks'] | null;
  modelsList: ModelDTO[] | null;
  modificationsList: ModificationsResponseDTO | null;
  groupsList: GroupDTO[];
  subGroupsList: GroupDTO[];
  parts: PartsModelDTO | null;
  scheme: string | null;
  selectedCar: {
    type?: string;
    mark?: string;
    model?: string;
    modification?: string;
    group?: string;
    parentGroup?: string;
    step?: number;
  };
  // selectedMark: MarkWithBrandProps | null;
}

export interface MarkWithBrandProps {
  id: string;
  brandId?: string;
  name: string;
  image: string;
  archival: boolean;
  engine: boolean;
  vin: boolean;
  hasModifications: boolean;
  searchParts: boolean;
}

export interface GetModelsByBrandProps {
  type: string;
  mark: string;
}

export interface GetModificationsByModelProps {
  type: string;
  mark: string;
  model: string;
}

export interface GetRequestModelsProps {
  type: string;
  mark: string;
}

export interface CatalogParamsProps {
  type: string;
  mark: string;
  model: string;
  modification: string;
  group: string;
  scheme: string;
  parts: string;
  page?: number;
  parentId: string;
}

export const SEARCH_BY_VIN_REQUEST = 'SEARCH_BY_VIN_REQUEST';
export const SEARCH_BY_VIN_SUCCESS = 'SEARCH_BY_VIN_SUCCESS';
export const SEARCH_BY_VIN_FAILURE = 'SEARCH_BY_VIN_FAILURE';

export const CATALOG_GET_LIST_REQUEST = 'CATALOG_GET_LIST_REQUEST';
export const CATALOG_GET_LIST_SUCCESS = 'CATALOG_GET_LIST_SUCCESS';
export const CATALOG_GET_LIST_FAILURE = 'CATALOG_GET_LIST_FAILURE';

export const GET_MODELS_REQUEST = 'GET_MODELS_REQUEST';
export const GET_MODELS_SUCCESS = 'GET_MODELS_SUCCESS';
export const GET_MODELS_FAILURE = 'GET_MODELS_FAILURE';

export const GET_MODIFICATION_REQUEST = 'GET_MODIFICATION_REQUEST';
export const GET_MODIFICATION_SUCCESS = 'GET_MODIFICATION_SUCCESS';
export const GET_MODIFICATION_FAILURE = 'GET_MODIFICATION_FAILURE';

export const GET_GROUPS_REQUEST = 'GET_GROUPS_REQUEST';
export const GET_GROUPS_SUCCESS = 'GET_GROUPS_SUCCESS';
export const GET_GROUPS_FAILURE = 'GET_GROUPS_FAILURE';

export const GET_SUBGROUPS_REQUEST = 'GET_SUBGROUPS_REQUEST';
export const GET_SUBGROUPS_SUCCESS = 'GET_SUBGROUPS_SUCCESS';
export const GET_SUBGROUPS_FAILURE = 'GET_SUBGROUPS_FAILURE';

export const GET_PARTS_REQUEST = 'GET_PARTS_REQUEST';
export const GET_PARTS_SUCCESS = 'GET_PARTS_SUCCESS';
export const GET_PARTS_FAILURE = 'GET_PARTS_FAILURE';

export const GET_SCHEME_REQUEST = 'GET_SCHEME_REQUEST';
export const GET_SCHEME_SUCCESS = 'GET_SCHEME_SUCCESS';
export const GET_SCHEME_FAILURE = 'GET_SCHEME_FAILURE';

export const RESET_CATALOG_DATA = 'RESET_CATALOG_DATA';
